import axios, { AxiosResponse } from "axios";
import { ILoggedUser, IChangePassword } from "../helpers/interfaces/user";
// import { history } from "../helpers/history";
// import EventBus from "../common/EventBus";
const API_URL = process.env.REACT_APP_API_URL;

class AuthService {

  async login(email: string, password: string): Promise<ILoggedUser> {
    return await axios.post(API_URL + "auth/login", {
      email_address: email,
      password: password
    })
      .then((response: AxiosResponse<any>) => {
        const data: ILoggedUser = response.data.data;
        if (data.token) {
          localStorage.setItem("user", JSON.stringify(data));
        }
        return response.data;
      });
  }

  logout(): void {
    localStorage.removeItem("user");
    sessionStorage.removeItem("practiceCategoryTab");
    sessionStorage.removeItem("lastPracticeSearch");
    // EventBus.dispatch("hideLoader");
    // history.push("/login");
    window.location.reload();
  }

  async getCurrentUser(): Promise<ILoggedUser | null> {
    const userStr: string | null = localStorage.getItem("user");
    if (!userStr) return null;

    try {
      const user: ILoggedUser = JSON.parse(userStr);
      if (!user?.token) {
        localStorage.removeItem("user");
        return null;
      }

      const decodedToken = this.parseJwt(user.token);
      if (!decodedToken?.exp || decodedToken.exp * 1000 < Date.now()) {
        localStorage.removeItem("user");
        return null;
      }

      return user;
    } catch (e) {
      localStorage.removeItem("user");
      return null;
    }
  }

  parseJwt(token: string): any {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  }

  async getIsAdmin(): Promise<boolean> {
    const userString: string | null = localStorage.getItem("user");

    if (!userString) return false;

    const user: ILoggedUser = JSON.parse(userString);
    // return user.roles.find((role: any) => role.code === "admin" || role.code === "amministrazione");
    return !!user.roles.find((role: any) => role.code === "ADM");
  }

  async getUserRoles(): Promise<any[]> {
    const userString: string | null = localStorage.getItem("user");

    if (!userString) return [];

    const user: ILoggedUser = JSON.parse(userString);
    return user.roles.map(item => item.code.toLowerCase());
  }

  changePassword(body: IChangePassword) {
    return axios.post<any>(API_URL + "user/changePassword", body)
      .then((response: AxiosResponse<any>) => { return response.data; })
      .catch((error) => { return Promise.reject(error); });
  }

  // recoverPassword(body: { registrationemail: string }) {
  //   return axios.post<{ registrationemail: string }>(API_URL + "passwordrecover", body)
  //     .then((response: AxiosResponse<any>) => { return response.data; })
  //     .catch((error) => { return Promise.reject(); });
  // }

  // resetPassword(body: any) {
  //   return axios.post<any>(API_URL + "passwordreset", body)
  //     .then(
  //       (response: AxiosResponse<any>) => { return response.data; })
  //     .catch((error) => { return Promise.reject(); });
  // }
}

export default new AuthService();
